var regex=/[\0-\x1F\x7F-\x9F]/;

export default regex;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/uc.micro/categories/Cc/regex.js